module.exports = __webpack_public_path__ + "files/92d9518940dbf96658dbef3b3753c1bb.png";